import type { ApiError } from "@/types/api";

export const isBrowserOffline = (): boolean =>
  typeof navigator !== "undefined" && !navigator.onLine;

export const isNetworkError = (error: unknown): boolean => {
  if (isBrowserOffline()) {
    return true;
  }

  if (error instanceof TypeError && error.message === "Failed to fetch") {
    return true;
  }

  if ((error as ApiError)?.status === 0) {
    return true;
  }

  return false;
};
